export var PlayerJumpShipErrorType;
(function (PlayerJumpShipErrorType) {
    PlayerJumpShipErrorType["ACCOUNT_NOT_FOUND"] = "accountNotFound";
    PlayerJumpShipErrorType["PLAYER_HAS_BEEN_UNDER_STAFF"] = "playerHasBeenUnderStaff";
    PlayerJumpShipErrorType["ACCOUNT_REPEAT"] = "accountRepeat";
    PlayerJumpShipErrorType["PLAYER_HAS_OTHER_JUMP_SHIP"] = "playerHasOtherJumpShip";
    PlayerJumpShipErrorType["OVER_REGISTER_TIME_LIMIT"] = "overRegisterTimeLimit";
    PlayerJumpShipErrorType["NOT_OVER_LOGIN_TIME_LIMIT"] = "notOverLoginTimeLimit";
    PlayerJumpShipErrorType["ACCOUNT_BALANCE_OVER_MONEY_LIMIT"] = "accountBalanceOverMoneyLimit";
    PlayerJumpShipErrorType["CANT_CROSS_AGENT_CHAIN"] = "cantCrossAgentChain";
})(PlayerJumpShipErrorType || (PlayerJumpShipErrorType = {}));
//# sourceMappingURL=PlayerJumpShipErrorType.js.map